import { useState } from 'react';
import type { ReactNode } from 'react';

import { Box, Collapse, FormLabel, IconButton } from '@mui/material';
import type { FormLabelProps } from '@mui/material';
import { MinusIcon, PlusIcon } from '@shared/ui/icons';

type CollapseFilterProps = {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  formLabelProps?: FormLabelProps;
};

export const CollapseFilter = (props: CollapseFilterProps) => {
  const { title, children, defaultOpen = true, formLabelProps } = props;
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        onClick={() => setIsOpen((prev) => !prev)}
        sx={{ cursor: 'pointer', userSelect: 'none', py: 0 }}
      >
        <FormLabel {...formLabelProps}>{title}</FormLabel>
        <IconButton size="small" tabIndex={-1}>
          {isOpen ? <MinusIcon fontSize="small" /> : <PlusIcon fontSize="small" />}
        </IconButton>
      </Box>
      <Collapse in={isOpen}>{children}</Collapse>
    </Box>
  );
};
